module.exports = __webpack_public_path__ + "static/img/zhuangshitu.f5dd82e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/zhuangshitu.png
// module id = 4cb6
// module chunks = 1